const REGISTRATION_LINK_PREFIX = `/auth/loyalty?next=`;
const REGISTRATION_LINK_SUFFIX = `#/register`;

export default function (): string {
  return `${REGISTRATION_LINK_PREFIX}${encodeURIComponent(
    window.location.pathname,
  )}${REGISTRATION_LINK_SUFFIX}`;
}
